import { StringHelper } from "../../../utilities/contracts/string-helper";

export class MemberItem {
  readonly memRecordId: string;
  readonly tenantId: string;
  readonly memberId: string;
  readonly m360MemberId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly dob: string;
  readonly gender: string;
  readonly potentialDuplicateRecords: string[];
  readonly conflictFlag: boolean;
  readonly conflictRecords: string[];

  constructor(options: Partial<MemberItem> = {}) {
    this.memRecordId = StringHelper.clean(options.memRecordId);
    this.tenantId = StringHelper.clean(options.tenantId);
    this.memberId = StringHelper.clean(options.memberId);
    this.m360MemberId = StringHelper.clean(options.m360MemberId);
    this.firstName = StringHelper.toTitleCase(StringHelper.clean(options.firstName));
    this.lastName = StringHelper.toTitleCase(StringHelper.clean(options.lastName));
    this.dob = StringHelper.clean(options.dob);
    this.gender = StringHelper.clean(options.gender);
    this.potentialDuplicateRecords = options.potentialDuplicateRecords;
    this.conflictRecords = options.conflictRecords;
    this.conflictFlag = options.conflictFlag;
  }
}
